import { useEffect, useState } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import { NAV_LINKS } from "../data/site";

export const Header = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-amber-500/15 bg-[#0B0C10]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 md:h-20 lg:px-8">
        <a
          href="#home"
          data-testid="header-logo-link"
          aria-label="Sandstorm Trading — back to top"
          className="flex items-center"
        >
          <img
            src="/brand/logo-horizontal-t.png"
            alt="Sandstorm Trading"
            width="1200"
            height="470"
            className="h-11 w-auto md:h-14"
          />
        </a>
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              href={l.href}
              className="text-sm font-medium text-zinc-300 transition-colors duration-200 hover:text-amber-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#shop"
            data-testid="shop-cards-nav-btn"
            className="gold-btn hidden px-5 py-2.5 text-sm sm:inline-flex"
          >
            <ShoppingBag className="h-4 w-4" aria-hidden="true" />
            Shop Cards
          </a>
          <button
            type="button"
            data-testid="mobile-menu-button"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-zinc-700 text-zinc-200 transition-colors hover:border-amber-400/50 hover:text-amber-300 lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="fixed inset-x-0 top-16 z-40 max-h-[calc(100svh-4rem)] overflow-y-auto border-b border-amber-500/15 bg-[#0B0C10] md:top-20 md:max-h-[calc(100svh-5rem)] lg:hidden"
        >
          <nav className="flex flex-col px-6 py-4" aria-label="Mobile">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                data-testid={`mobile-nav-link-${l.id}`}
                href={l.href}
                onClick={() => setOpen(false)}
                className="border-b border-zinc-800/60 py-4 text-lg font-semibold text-zinc-100 transition-colors last:border-0 hover:text-amber-300"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#shop"
              data-testid="mobile-shop-cards-btn"
              onClick={() => setOpen(false)}
              className="gold-btn mb-3 mt-5 px-6 py-3.5 text-base"
            >
              <ShoppingBag className="h-5 w-5" aria-hidden="true" />
              Shop Cards
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
